import { render, staticRenderFns } from "./testsTab.vue?vue&type=template&id=12955de7&"
import script from "./testsTab.vue?vue&type=script&lang=js&"
export * from "./testsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports